export function parseMoney(input) {
  let text = String(input ?? '').trim().toLocaleLowerCase('tr-TR').replace(/₺|tl|türk lirası/g,'').trim();
  if (!text) return null;
  let multiplier = 1;
  if (/milyon|m$/.test(text)) { multiplier=1000000; text=text.replace(/milyon|m$/g,''); }
  else if (/bin|k$/.test(text)) { multiplier=1000; text=text.replace(/bin|k$/g,''); }
  text=text.replace(/\s/g,'');
  if (/^\d{1,3}(\.\d{3})+(,\d{1,2})?$/.test(text)) text=text.replace(/\./g,'').replace(',','.');
  else if (/^\d{1,3}(,\d{3})+(\.\d{1,2})?$/.test(text)) text=text.replace(/,/g,'');
  else text=text.replace(',','.');
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
  const amount=Number(text)*multiplier;
  return Number.isFinite(amount) && amount>0 && amount<=1000000000000 ? Math.round(amount*100)/100 : null;
}
export const formatMoney = amount => new Intl.NumberFormat('tr-TR',{maximumFractionDigits:2}).format(amount)+' TL';
const ones=['','bir','iki','üç','dört','beş','altı','yedi','sekiz','dokuz'],tens=['','on','yirmi','otuz','kırk','elli','altmış','yetmiş','seksen','doksan'];
function triple(n) { return [n>=100?(Math.floor(n/100)===1?'yüz':ones[Math.floor(n/100)]+' yüz'):'',tens[Math.floor(n%100/10)],ones[n%10]].filter(Boolean).join(' '); }
export function moneyWords(amount) {
  let n=Math.floor(amount),parts=[];
  for(const [factor,label] of [[1000000000000,'trilyon'],[1000000000,'milyar'],[1000000,'milyon'],[1000,'bin'],[1,'']]){
    const group=Math.floor(n/factor);n%=factor;if(group)parts.push(group===1 && factor===1000?'bin':[triple(group),label].filter(Boolean).join(' '));
  }
  const cents=Math.round((amount-Math.floor(amount))*100);
  return (parts.join(' ')||'sıfır')+' Türk lirası'+(cents?' '+triple(cents)+' kuruş':'');
}
export function housingAmountSuggestion(amount) { return amount && amount<1000000 ? amount*(amount<1000?1000000:amount<10000?1000:amount<100000?100:10) : null; }
